function init_hall2019game(from_php){
    var main=$(".place.hall2019game");
    
    var mobile=_isMobileObj.take();
//    mobile=1;
    if(mobile){
        main.addClass("mobile");
    }
    if(_ON_DEV){
        console.log(from_php);
    }
    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }
    if(from_php.was_showed==0 && false){
        _semaphoreXHR.tryClear();
        $.goToLocation("hall2019init/"+from_php.girl_id+"/");
        return false;
    }
    $.addToPlacePreloader(function(){
                //on load
    },[],{addToLoader:1});
    var guitarGameObj,gameLoader=new afterInit(),buttonSlow;
    var girlSetObj;
    var mobileBut=[
        {
            url: _IMG_SERV+"/gfx/place/hall2019game/ui/mobile/1.png",
            pos:[235,675]
        },
        {
            url: _IMG_SERV+"/gfx/place/hall2019game/ui/mobile/2.png",
            pos:[640,675]
        },
        {
            url:_IMG_SERV+"/gfx/place/hall2019game/ui/mobile/3.png",
            pos:[1045,675]
        }
    ];
    
    function setMobileGame(mobile){
        if(mobile){
            main.addClass("mobile");
        }
        else{
            main.removeClass("mobile");
        }
        if(mobile){
            guitarGameObj.uiContainer.x=672;
            guitarGameObj.uiContainer.y=660;
            guitarGameObj.initMobile();
            guitarGameObj.buttonContainerMobile.alpha=1;
        }
        else{
            guitarGameObj.uiContainer.x=612;
            guitarGameObj.uiContainer.y=24;
            guitarGameObj.buttonContainerMobile.alpha=0;
        }
        guitarGameObj.conf.mobile=mobile;
    }
    
    function prepareGuitarInit(){
        var addImagesMore={
            cover:_IMG_SERV+"/gfx/place/hall2019game/guitar/bar_cover.png",
            cover_circle:_IMG_SERV+"/gfx/place/hall2019game/guitar/circle/down.png",
            girl1:_IMG_SERV+"/gfx/place/hall2019game/guitar/girls/cherry/skeleton.json",
            girl2:_IMG_SERV+"/gfx/place/hall2019game/guitar/girls/lola/skeleton.json",
            girl3:_IMG_SERV+"/gfx/place/hall2019game/guitar/girls/sanshi/skeleton.json",
            portal:_IMG_SERV+"/gfx/place/hall2019game/effects/portal/skeleton.json",
            cauldron_plum1:_IMG_SERV+"/gfx/place/hall2019game/effects/plum1/skeleton.json",
            cauldron_plum2:_IMG_SERV+"/gfx/place/hall2019game/effects/plum2/skeleton.json",
            cauldron_plum3:_IMG_SERV+"/gfx/place/hall2019game/effects/plum3/skeleton.json",
            cauldron_plum4:_IMG_SERV+"/gfx/place/hall2019game/effects/plum4/skeleton.json",
            skull:_IMG_SERV+"/gfx/place/hall2019game/effects/skull/skeleton.json"
        };
        var i;
        for(i=1;i<=14;i++){
            addImagesMore["girl"+i]=_IMG_SERV+"/gfx/place/hall2019game/guitar/girls/"+$.takeGirlImage(i)+"/skeleton.json";
        }


        var addImages={
            "stone_left":_IMG_SERV+"/gfx/place/hall2019game/ui/stone_left.png",
            "stone_center":_IMG_SERV+"/gfx/place/hall2019game/ui/stone_center.png?2",
            "stone_right":_IMG_SERV+"/gfx/place/hall2019game/ui/stone_right.png",
            "mobile_down":_IMG_SERV+"/gfx/place/hall2019game/ui/mobile/down.png",
            "candle":_IMG_SERV+"/gfx/place/hall2019game/ui/candle.png",
            "candle_fire":_IMG_SERV+"/gfx/place/hall2019game/ui/candle_fire.png",
            "belt_score":_IMG_SERV+"/gfx/place/hall2019game/ui/belt_green.png?2",
            "belt_time":_IMG_SERV+"/gfx/place/hall2019game/ui/belt_pink.png?2",
            "butfail":_IMG_SERV+"/gfx/place/dildogame/guitar/red.png",
            "bomb":_IMG_SERV+"/gfx/place/dildogame/guitar/bomb.png",
            "but":_IMG_SERV+"/gfx/place/dildogame/guitar/but/but.png",
            "but_1d":_IMG_SERV+"/gfx/place/hall2019game/guitar/but/1d.png",
            "but_1u":_IMG_SERV+"/gfx/place/hall2019game/guitar/but/1u.png",
            "but_2d":_IMG_SERV+"/gfx/place/hall2019game/guitar/but/2d.png",
            "but_2u":_IMG_SERV+"/gfx/place/hall2019game/guitar/but/2u.png",
            "but_3d":_IMG_SERV+"/gfx/place/hall2019game/guitar/but/3d.png",
            "but_3u":_IMG_SERV+"/gfx/place/hall2019game/guitar/but/3u.png",
            "err_1d":_IMG_SERV+"/gfx/place/hall2019game/guitar/err/1d.png",
            "err_1u":_IMG_SERV+"/gfx/place/hall2019game/guitar/err/1u.png",
            "err_2d":_IMG_SERV+"/gfx/place/hall2019game/guitar/err/2d.png",
            "err_2u":_IMG_SERV+"/gfx/place/hall2019game/guitar/err/2u.png",
            "err_3d":_IMG_SERV+"/gfx/place/hall2019game/guitar/err/3d.png",
            "err_3u":_IMG_SERV+"/gfx/place/hall2019game/guitar/err/3u.png",
        };




        girlSetObj=new hall2019girlSet({girlObj:from_php.suit_arr});
        addImagesMore=$.extend(true,addImagesMore,girlSetObj.addToLoader());

        var mobile_extend=170;

        var itemScale=[35,70];
        var wrongControlIndex=_moduleTimeHandler.getNewIndex();
        guitarGameObj=new guitarGame(main.find("#gameWrapJS"),{
            buttonContainerPos:[0,0],
            addImagesMore:addImagesMore,
            addImages:addImages,
            marginTopMobile:0,
            mobile_extend:mobile_extend,
            uiConf:{
                "container_all":{size:[800,73],pos:[612,24]},
                "stone_center":{pos:[205,25]},
                "stone_left":{pos:[0,8]},
                "stone_right":{pos:[545,9]},
                "belt_score":{pos:[217,38]},
                "belt_time":{pos:[218,53]},
                "candle":{pos:[17,-10],zIndex:-1},
                "fire_pos":[
                    [29,11],[53,14],[74,16],[97,14],[116,18]
                ],
                txtScore:{
                    pos:[75,53],
                    font_color:"#97ef2f",
                    border_color:"#171439",
                    border_size:4,
                    font_size:32,
                },
                txtBonus:{
                    pos:[171,55],
                    font_color:"#ffffff",
                    border_color:"#8a9e27",
                    border_size:3,
                }
            },
            pathConf:[
                {
                    url:_IMG_SERV+"/gfx/place/hall2019game/guitar/path/left.png",
                    anchor:[0,1],
                    padding_up:[70,230],//for circle start
                    padding_down:[-21,-35],//for path
                },{
                    url:_IMG_SERV+"/gfx/place/hall2019game/guitar/path/center.png",
                    anchor:[0.5,1],
                    padding_up:[0,230],
                    padding_down:[-1,-33]
                },{
                    url:_IMG_SERV+"/gfx/place/hall2019game/guitar/path/right.png",
                    anchor:[1,1],
                    padding_up:[-62,230],
                    padding_down:[20,-33]

                }
            ],
            gameProgress:from_php.gameProgress,
            gameConf:from_php.game_conf.stages,
            hard_id:from_php.hard_id,
            buttonPos:[[125,565],[240,565],[350,565]],//buttonPos:[[118,561],[240,561],[360,561]],
            buttonView:[
                [{img:"but_1d",pos:[77,548],anchor:[0,0]},{img:"but_1u",pos:[77,520],anchor:[0,0]}],
                [{img:"but_2d",pos:[188,548],anchor:[0,0]},{img:"but_2u",pos:[188,518],anchor:[0,0]}],
                [{img:"but_3d",pos:[298,548],anchor:[0,0]},{img:"but_3u",pos:[297,520],anchor:[0,0]}]
            ],
            errView:[
                [{img:"err_1d",pos:[77,548],anchor:[0,0]},{img:"err_1u",pos:[77,520],anchor:[0,0]}],
                [{img:"err_2d",pos:[188,548],anchor:[0,0]},{img:"err_2u",pos:[188,518],anchor:[0,0]}],
                [{img:"err_3d",pos:[298,548],anchor:[0,0]},{img:"err_3u",pos:[297,520],anchor:[0,0]}]
            ],
            itemScale:itemScale,
            mobile:mobile,
            bonus2:from_php.game_conf.bonus2,
            button_mobile_path:mobileBut,
            score_repeat:intval(from_php.game_conf.repeat.val),
            onWrongControl:function(button_id){
                
                var obj=main.find("#wrongControl");
                obj.css({left:mobileBut[button_id].pos[0]+"px",top:mobileBut[button_id].pos[1]+"px"}).show();
                _moduleTimeHandler.setOne(wrongControlIndex,function(){
                    obj.hide();
                },2000);
                
                
                
            },
            onLoad:function(){
                this.externalContainer.addChild(new myPixiElement.img({img:"cover",anchor:[0,1],pos:[0,780]}));

//                    this.externalContainer.addChild(new myPixiElement.img({img:"cover",anchor:[0,1],pos:[0,780]}));

                this.buttonContainer.addChild(new myPixiElement.img({img:"cover_circle",anchor:[0,0],pos:[77,548]}));

                this.externalContainer.x=0;
                this.externalContainer.y=0;

                girlSetObj.init(this.resources);
                this.externalContainer.addChild(girlSetObj);




                var hallIndex=_moduleTimeHandler.getNewIndex();
                function moveWitch(){
                    girlSetObj.startMove();
                    _moduleTimeHandler.setOne(hallIndex,function(){
                        moveWitch();
                    },mt_rand(2000,4500));
                }
                moveWitch();


                

//                    _mySound.playSound("dildo_smash");
//                    _moduleTimeHandler.add(function(){
//                        _mySound.playSound("girl_moan_new");
//                    },2500);

                

            },
            onLoadAfter:function(){
                
                setMobileGame(mobile);
                this.buttonDownContainer.addChild(
                    new myPixiElement.spine({
                        img:"portal",
                        spine_conf:{
                            spineResource:this.resources,
                            anim_loop:true,
                        },


                    })       
                );
                var plumArr=[];
                var i;
                for(i=0;i<=3;i++){
                    plumArr.push(
                        new myPixiElement.spine({
                            img:"cauldron_plum"+(i+1),
                            spine_conf:{
                                spineResource:this.resources,
                                auto_start:false,
                                onAnimComplete:function(){
                                    this.alpha=0;
                                }
                            },


                        })
                    );
                    plumArr[i].alpha=0;
                    this.externalContainer.addChild(plumArr[i]);
                }
                var plumIndex=_moduleTimeHandler.getNewIndex();
                var plumConf={
                    pos:[23,580],
                    size:[476,48]
                };
                function makePlum(){
                    _moduleTimeHandler.setOne(plumIndex,function(){
                        var plum=plumArr[mt_rand(0,plumArr.length-1)];
                        plum.x=plumConf.pos[0]+mt_rand(0,plumConf.size[0]);
                        plum.y=plumConf.pos[1]+mt_rand(0,plumConf.size[1]);
                        plum.alpha=1;
                        plum.playAnim("animation");
                        if(mt_rand(1,100)>50){
                            _mySound.playSound("hall2019_bubble");
                        }
                        
                        makePlum();
                    },mt_rand(500,1000));
                }
                makePlum();
                
                var obj = new PIXI.Graphics();
                obj.beginFill(0x000000); // black color
                obj.drawRoundedRect(-20, 0, 700, 100, 12);
                obj.endFill();
                obj.alpha=0.4;
                
                
                this.uiContainer.addChildAt(obj,0);
                
                
                
                $.triggerPlacePreloader(1);
                gameLoader.load();
            },
            onEnd:function(){
                var res=guitarGameObj.prepareResAjax();
                var wait=20;

                var to_post={
                    game_conf:Base64.encode(secureStr),
                    val:res.score,
                    val_max:res.score_max,
                    is_boss:res.is_boss,
                    fail_id:res.fail_id
                };
                if(res.fail_id==2){
                    wait=3000;
                    _mySound.playSound("pvpfinish");
//                        dildoHeroObj.myPlayAnim("bad",1);
                }

                _mySound.stopSound("dildo_smash");

                postAjax(to_post,{wait:wait});

            },
            onItem:function(line_id){
                var line2name=["throw_left","throw_center","throw_right"];
//                    dildoHeroObj.myPlayAnim(line2name[line_id]);

                //bad, good1,good2,throw_center,throw_left,throw_right
            },
            onUpdate:function(delta){
                girlSetObj.myUpdate(delta);


//                    dildoHeroObj.myUpdate(delta);
            },
            onBoss:function(){
//                    dildoHeroObj.myPlayAnim("good"+mt_rand(1,2),1);
                var cells=main.find("#gameInfoBoss .box");
                var timeIndexAnim=_moduleTimeHandler.getNewIndex();
                var timeIndexQueue=_moduleTimeHandler.getNewIndex();
                var howlong_arr=[200,1000,200];
                function useBox(i){
                    if(i>1){
                        return false;
                    }
                    cells.eq(i).css("opacity",0).removeClass("hide");
                    _moduleTimeHandler.queueAdd(timeIndexQueue,function(){
                        cells.eq(i).animate({'opacity':1},howlong_arr[0]);
                        _moduleTimeHandler.setOne(timeIndexAnim,function(){
                            _moduleTimeHandler.queueTrigger(timeIndexQueue);
                        },howlong_arr[0]+howlong_arr[1]);
                    });
                    _moduleTimeHandler.queueAdd(timeIndexQueue,function(){
                        cells.eq(i).animate({'opacity':0},howlong_arr[2])
                        _moduleTimeHandler.setOne(timeIndexAnim,function(){
                            _moduleTimeHandler.queueTrigger(timeIndexQueue);
                        },howlong_arr[2]);
                    });
                    _moduleTimeHandler.queueAdd(timeIndexQueue,function(){
                        cells.eq(i).addClass("hide");
                       useBox(i+1);
                    });
                    _moduleTimeHandler.queueTrigger(timeIndexQueue);
                }
                useBox(0);


            },
            onSlowTrigger:function(){
                buttonSlow.animate({'opacity':0},600);
            },
            onPrepareItem:function(line_id){
                var g_id=mt_rand(1,14);
                var res=  {
                    img:"girl"+g_id,
                    anim_type:"spine",
                    spine_conf:{
                        anim_loop:true,
                        anim_name:"animation",
                        spineResource:this.resources,
                    }
                };
                return res;
            },
            onItemFall:function(line_id,pos,img,item){
                //itemScale
                try{
                    item.hideHero();


                }
                catch(e){}
                var thc=this;
                var scale_max=itemScale[1];
                var animObj=new myPixiObj.drawCustom({
                    pos_start:[pos[0],pos[1]],
                    pos_end:[pos[0],pos[1]+200],
                    scale_arr:[scale_max,scale_max],
                    img:img,
                    step_max:30,
                    anim_type:"spine",
                    spine_conf:{
                        anim_loop:true,
                        anim_name:"animation",
                        spineResource:this.resources,
                    },
                    onEndAnim:function(){
                        
                        
                        var animObj=new myPixiObj.drawCustom({
                            pos_start:[pos[0],pos[1]+105],
                            pos_end:[pos[0],pos[1]+105],
                            img:"skull",
                            step_max:160,
                            scale_arr:[scale_max,scale_max],
                            anim_type:"spine",
                            spine_conf:{
                                anim_name:"animation",
                                spineResource:thc.resources,
                            }
                        });
                        thc.animArr.push(animObj);
                        thc.animContainer.addChild(animObj);
                    }
                });
                this.animArr.push(animObj);
                this.animContainer.addChild(animObj);
                _mySound.playSound("hall2019_scream");
                
                //skull

            },
            onScore:function(pos,line_id,img){
//                    var animObj=new myPixiObj.drawCustom({
//                        pos_start:[pos[0],pos[1]],
//                        pos_end:[pos[0],pos[1]],
//                        opacity_arr:[100,0],
//                        scale_arr:[itemScale[1],itemScale[1]],
//                        img:img,
//                        step_max:30,
//                        anim_type:"spine",
//                        spine_conf:{
//                            anim_loop:true,
//                            anim_name:"animation",
//                            spineResource:this.resources,
//                        },
//                    });
//                    this.animArr.push(animObj);
//                    this.animContainer.addChild(animObj);


                var puffObj=new myPixiObj.drawCustom({
                    pos_start:[pos[0],pos[1]-20],
                    pos_end:[pos[0],pos[1]-20],
                    img:"puff_pink",
                    step_max:30,
                    anim_type:"spine",
                    spine_conf:{
                        anim_name:"animation",
                        spineResource:this.resources,
                    },
                });



                this.animArr.push(puffObj);
                this.animContainer.addChild(puffObj);
            }
        });
    }
    prepareGuitarInit();
    
    
    var semaphoreSuit= new mySemaphore();
    
    var girl_id=intval(from_php.girl_id);
    var gameInitObj=new afterInit();
    
    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex()
    };
    
    var girl_name=$.takeGirlImage(girl_id);
    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var gameLog=[];
    var secureStr=from_php.secure;
    var ajaxTimeHandler=_moduleTimeHandler.getNewIndex();
    
    function postAjax(to_send,conf){
        if(typeof conf=="undefined"){
            conf={};
        }
        conf=$.extend({wait:20,onEnd:function(){}},conf);
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"hall2019game"};
            data_send=$.extend(data_send,to_send);
            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                    
                    
                    _moduleTimeHandler.setOne(ajaxTimeHandler,function(){
                        if(intval(data.was_ended)>intval(from_php.was_ended)){
                            _mySound.playSound("girl_moan");
                            $.goToLocation("hall2019anim",{show_last:1});
                            
                            return false;
                        }
                        else if(intval(data.was_ended)>0 && data.was_paid==0){
                            $.goToLocation("hall2019game/"+girl_id+"/");
                            return false;
                        }
                        from_php=$.extend(from_php,data);
                        if(_ON_DEV){
                            console.log(from_php);
                        }
                        updateState();

                        semaphoreSuit.clear();
                        conf.onEnd();
                    },conf.wait);
                        
                }
                
            },"json");
        }
    }
    
    function updateState(){
        
        if(from_php.was_paid){
            if(from_php.was_paid==1){
                showState("game_init");
            }
            else{
                showState("game");
            }
            
            
        }
        else{
            if(from_php.repeat_val && from_php.was_error){
                showState("val_lose");
                
                /*
                 * repeat_val
                 * val_need
                 * was_error
                 * 
                 * 
                 */
                
                //can repeat, lose_val
            }
            else if(typeof from_php.res!="undefined"){
                if(from_php.game_conf.state.type=="coin"){
                    showState("coin_win");
                    /*
                     * res:
                     * coin_have
                     * coin_add
                     * coin_need
                     * try_count_have
                     * try_count_add
                     * 
                     */
                }
                else{
                    showState("val_win");
                    /*
                     * res:
                     * val_have
                     * val_need
                     * 
                     * 
                     * 
                     */
                }
            }
            else{
                if(from_php.try_count>0){
                    if(from_php.part_ended==0 && from_php.coins==0){
                        showState("before_init");
                    }
                    else{
                        showState("init");
                    }
                    
                    
                }
                else{
                    showState("need_try");
                }
            }
        }
    }
    
    
    function init(){
        main.find(".butNextLevelStartJS").click(function(){
            _mySound.playSound("button_click");
            postAjax({start_game:1});
        });
        
        
        
        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
           var th=$(this),premium_count=intval(th.attr("data-need"));
           $.payByPremium(premium_count,function(){
                postAjax({buy_repeat:1});
            });
        });
        
        
        
        
        updateState();
    }
    
    
    var stateIndex={
        "game":[_moduleTimeHandler.getNewIndex()]
    };
    var stateFun={
        "coin_win":function(win){
            var i,bum,is_premium="",html="";
            for(i=0;i<from_php.res.coin_add_max;i++){
                if(i<from_php.res.coin_add){
                    if(i>=from_php.res.coin_add/2 && from_php.game_conf.bonus1){
                        is_premium=" premium";
                    }
                    html+="<div class='star have"+is_premium+"'></div>";
                }
                else{
                    html+="<div class='star'></div>";
                }
            }
            win.find(".starWrap").html(html);
            if(is_premium){
                win.find(".starWrap").addClass("premium");
            }
            
            var str="0";
            if(from_php.res.try_count_add>0){
                str="+"+from_php.res.try_count_add;
            }
            win.find(".putRes[data-type='try_count_add']").html(str);
        },
        "val_win":function(win){
            win.find(".putRes[data-type='val_have']").html(numberFormat(from_php.res.val_have,0,0));
            win.find(".putRes[data-type='val_need']").html(numberFormat(from_php.res.val_need,0,0));
            
            
        },
        "val_lose":function(win){
            win.find(".reasonJS").html(from_php.langs["fail"+from_php.was_error]);
            win.find(".putRes[data-type='repeat_val']").html(numberFormat(from_php.repeat_val,0,0));
            var val_need=5000;
            from_php.repeat_val=intval(from_php.repeat_val);
            from_php.repeat_moves=intval(from_php.repeat_moves);
            if(from_php.repeat_val>0){
                val_need=Math.ceil(from_php.repeat_val/(from_php.repeat_moves/100));
            }
            win.find(".putRes[data-type='val_need']").html(numberFormat(val_need,0,0));
//            var txt=from_php.langs["fail"+from_php.was_error];
//            win.find(".failText").html(txt);
            
            
            var repeat_type="premium";
            if(from_php.try_count>=from_php.conf_user.currency_repeat){
                repeat_type="currency";
            }
//            if(from_php.repeat_moves<10 || 1==1){
//                repeat_type="";
//            }
            
            
            win.find(".priceCellJS").addClass("hide");
                    
            if(repeat_type){        
                win.find(".priceCellJS").filter("[data-price='"+repeat_type+"']").removeClass("hide");
                win.find(".butRepeatJS").off("click.repeat").on("click.repeat",function(){
                    var th=$(this),repeat_type=0,repeat_names={"currency":1,"premium":2};
                    var repeat_name=th.attr("data-price");
                    if(typeof repeat_names[repeat_name]!="undefined"){
                        repeat_type=repeat_names[repeat_name];
                    }
                    $.goToLocation("hall2019game/"+girl_id+"/",{buy_repeat:1,repeat_type:repeat_type})
    //                postAjax({buy_repeat:1,repeat_type:repeat_type});
                });
            }
        },
        "before_init":function(win){
            showState("init");
        },
        "init":function(win){
            var infoBox=win.find(".mainColl.info");
            infoBox.attr("data-isMobile",mobile);
            infoBox.find(".uiRow").off("click").on("click",function(){
                if(gameLoader.wasLoaded()){
                    mobile=(mobile+1)%2;
                    infoBox.attr("data-isMobile",mobile);
                    _isMobileObj.set(mobile);
                    win.find(".textfill").textfill();
                    
                    
                    setMobileGame(mobile);
                }
               
            });
            
        },
        "need_try":function(win){
            _timerManager.addTimer(".place.hall2019game .timerKeyWaitJS",from_php.try_time,1);
        },
        "game":function(win){
            gameCover.addClass("hide");
            main.find(".showOnGameJS").removeClass("hide");
            buttonSlow=main.find("#buttonSlowGameJS");
            buttonSlow.css("opacity",1);
            
            
            gameLoader.addFun(function(){
                buttonSlow.off("click").click(function(){
                    guitarGameObj.makeGameSlower();
                });
                
                
                function toDo(from_php){
                    
                    
                    
                    this.conf.gameProgress=from_php.gameProgress;
                    
                    if(typeof this.conf.gameProgress[this.state]!="undefined"){
                        this.gameProgress=this.conf.gameProgress[this.state];
                        delete this.conf.gameProgress[this.state];
                    }
                    
                    
                    
                    this.beforeStart();
                    
                    this.uiObj.beltScore.setValMax(this.res[this.state].score_max);
                    this.uiObj.beltTimer.setValMax(this.res[this.state].howlong_max);
                            
                            
                };
                toDo.call(guitarGameObj,from_php);
                
                
                
                
//                if(typeof conf.gameProgress[this.state]!="undefined"){
//                    this.gameProgress=conf.gameProgress[this.state];
//                    delete conf.gameProgress[this.state];
//                }
                main.find(".hideOnGameJS").addClass("hide");
                main.find(".showOnGameJS").removeClass("hide");
                guitarGameObj.start();
                girlSetObj.start();
            });
            
            
             
             
        },
        game_init:function(win){
            main.find(".wrapGirlUI.hideOnGameJS").addClass("hide");
            var but=win.find(".formSubmit");
            var step=0;
            _moduleTimeHandler.add(function(){
                step=(step+1)%2;
                if(step==0){
                    but.addClass("blink");
                }
                else{
                    but.removeClass("blink");
                }
            },1000);
            main.find(".butStartAfterInitJS").click(function(){
                 postAjax({
                    show_game:1
                });
        
            });
           
            
        }
    };
    function showState(state){
        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.gameninja .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);
        
        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }
        
        
        
        
        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        var win=main.find(".stateJS[data-state='"+state+"']");
        stateFun[state](win);
        
        main.find(".textfill").textfill();
        state_cur=state;
    }
    
    
    
    init();

//    showState("game");

//    gameCanv.one("gameReady",function(){
        main.find(".preloadJS").addClass("hide");
        main.find(".preloadAfterJS").removeClass("hide");
        gameInitObj.load();
//    });
    
    from_php.game_conf.girl_id=from_php.girl_id;
    
     _moduleEvents.one("moduleClear",function(){
        _mySound.stopSoundAll();
    });
   
      
    $.handleBottomMenu();
    $.handleSelect();
    
    
    
    
    

}